import { useState } from "react";
import { Building2, Plus } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import ContaBancariaItem from "./ContaBancariaItem";
import NovaContaModal from "./NovaContaModal";

// FIN-3 — Seção CONTAS BANCÁRIAS.

export default function ContasBancariasSection({
  bankAccounts,
  isLoading,
  createAccount,
  updateAccount,
  deleteAccount,
}) {
  const [modalState, setModalState] = useState({ open: false, account: null });

  const openCreate = () => setModalState({ open: true, account: null });
  const openEdit = (acc) => setModalState({ open: true, account: acc });
  const closeModal = () => setModalState({ open: false, account: null });

  const handleSubmit = async (payload, id) => {
    if (id) {
      // Editar — não envia user_id (não existe no UpdateAccountRequest schema)
      const { user_id: _ignored, ...rest } = payload;
      await updateAccount(id, rest);
    } else {
      await createAccount(payload);
    }
  };

  const handleDelete = async (acc) => {
    if (window.confirm(`Apagar conta "${acc.name}"? Essa ação não pode ser desfeita.`)) {
      try { await deleteAccount(acc.id); } catch (_) { /* hook trata error */ }
    }
  };

  const isEmpty = !isLoading && (bankAccounts || []).length === 0;

  return (
    <section data-testid="contas-bancarias">
      <header className="flex items-center justify-between mb-4">
        <h3 className="text-caption font-semibold uppercase text-foreground-muted" style={{ letterSpacing: "0.10em" }}>
          <Building2 className="w-3.5 h-3.5 inline mr-1.5" aria-hidden="true" />
          Contas bancárias
        </h3>
        <Button variant="ghost" size="sm" onClick={openCreate} data-testid="contas-bancarias-new">
          <Plus className="w-3.5 h-3.5" /> Nova conta
        </Button>
      </header>

      {isEmpty ? (
        <Card variant="elevated" className="glass-card py-10 px-6" data-testid="contas-bancarias-empty">
          <EmptyState
            icon={Building2}
            title="Sem contas bancárias cadastradas"
            description="Cadastre suas contas pra acompanhar saldos e movimentação."
            action={(
              <Button variant="secondary" size="md" onClick={openCreate}>
                <Plus className="w-4 h-4" /> Criar conta bancária
              </Button>
            )}
          />
        </Card>
      ) : (
        <div className="flex flex-col gap-2.5">
          {bankAccounts.map(acc => (
            <ContaBancariaItem
              key={acc.id}
              account={acc}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}

      <NovaContaModal
        open={modalState.open}
        onOpenChange={(o) => { if (!o) closeModal(); }}
        account={modalState.account}
        onSubmit={handleSubmit}
      />
    </section>
  );
}
